import React from 'react';

interface MinusIconProps {
  backgroundColor?: string;
  size?: number;
  opacity?: number;
}

const MinusIcon: React.FC<MinusIconProps> = ({
  backgroundColor = '#000',
  size = 24,
  opacity = 1,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ opacity }}
  >
    <circle cx="12" cy="12" r="12" fill={backgroundColor} />
    <path d="M7 12H17" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default MinusIcon;
